define(["require", "exports", "./AdminService", "./CommonService", "./FacilityService", "./MobileService", "./PermitApplicationService", "./PublicReportService", "./SmaService", "./StockRouteNetworkManagementService", "./WaterAgreementApplicationService", "./UserService"], function (require, exports, AdminService_1, CommonService_1, FacilityService_1, MobileService_1, PermitApplicationService_1, PublicReportService_1, SmaService_1, StockRouteNetworkManagementService_1, WaterAgreementApplicationService_1, UserService_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrmsServiceManager = void 0;
    class SrmsServiceManager {
        constructor() {
            Object.defineProperty(this, "tableCache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {}
            });
        }
        static get Instance() {
            if (this.instance == null) {
                this.instance = new SrmsServiceManager();
            }
            return this.instance;
        }
        get User() {
            if (this.tableCache[0] == null) {
                this.tableCache[0] = new UserService_1.UserService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[0];
        }
        get Admin() {
            if (this.tableCache[1] == null) {
                this.tableCache[1] = new AdminService_1.AdminService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[1];
        }
        get Common() {
            if (this.tableCache[2] == null) {
                this.tableCache[2] = new CommonService_1.CommonService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[2];
        }
        get Facility() {
            if (this.tableCache[3] == null) {
                this.tableCache[3] = new FacilityService_1.FacilityService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[3];
        }
        get Mobile() {
            if (this.tableCache[4] == null) {
                this.tableCache[4] = new MobileService_1.MobileService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[4];
        }
        get PermitApplication() {
            if (this.tableCache[5] == null) {
                this.tableCache[5] = new PermitApplicationService_1.PermitApplicationService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[5];
        }
        get PublicReport() {
            if (this.tableCache[6] == null) {
                this.tableCache[6] = new PublicReportService_1.PublicReportService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[6];
        }
        get Sma() {
            if (this.tableCache[7] == null) {
                this.tableCache[7] = new SmaService_1.SmaService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[7];
        }
        get StockRouteNetworkManagement() {
            if (this.tableCache[8] == null) {
                this.tableCache[8] = new StockRouteNetworkManagementService_1.StockRouteNetworkManagementService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[8];
        }
        get WaterAgreementApplication() {
            if (this.tableCache[9] == null) {
                this.tableCache[9] = new WaterAgreementApplicationService_1.WaterAgreementApplicationService(SrmsServiceManager.HttpProtocol, SrmsServiceManager.HostName, SrmsServiceManager.ServiceName, SrmsServiceManager.ProxyUrl);
            }
            return this.tableCache[9];
        }
    }
    exports.SrmsServiceManager = SrmsServiceManager;
});
